import { classNames } from "@frec-js/common-web";
import { Badge } from "@mantine/core";
import Image from "next/image";
import Link from "next/link";
import { FC, ReactNode } from "react";

import { AnimatedIcon } from "../components/Button";
import { PostType } from "../utils/blogApi";
import { FrecWebPath } from "../utils/paths";
import { BlogMetaCategory } from "./BlogMetaCategory";
import { BlogMetaDate } from "./BlogMetaDate";
import { BlogMetaReadingTime } from "./BlogMetaReadingTime";

export const FeaturedArticle: FC<{
  post: PostType;
  className?: string;
  description?: ReactNode;
}> = ({ post, className, description }) => {
  return (
    <Link
      href={`${FrecWebPath.blog}/${post.slug}`}
      className={classNames(
        "group flex flex-col gap-12 lg:flex-row",
        className,
      )}
    >
      <div className="shrink-0 overflow-hidden">
        {post.featured_image ? (
          <Image
            src={post.featured_image}
            width={500}
            height={372}
            className="h-[372px] w-full object-cover transition-all duration-300 group-hover:scale-110 lg:w-[500px]"
            alt=""
          />
        ) : (
          <div className="bg-frecDarkBeige h-[372px] w-full lg:w-[500px]"></div> // If there is no featured image, show a beige background by default
        )}
      </div>
      <div className="flex min-w-0 flex-col gap-4">
        <BlogMetaCategory
          className="text-frecXDarkGray text-[14px] font-medium tracking-wide uppercase"
          post={post}
        />
        <h3 className="line-clamp-2 text-[32px] font-medium tracking-tight lg:text-[40px]">
          {post.title}
        </h3>
        <div className="text-frecXDarkGray text-14 flex flex-wrap items-center gap-4">
          <BlogMetaDate showUpdated={false} post={post} />
          <BlogMetaReadingTime post={post} />
          {post.status !== "publish" && (
            <Badge color="red">{post.status}</Badge>
          )}
        </div>
        <span className="text-[20px]">{description}</span>
        <span className="text-frecBlue hover:text-underline mt-6 flex w-fit items-center pr-6 font-medium">
          Read article <AnimatedIcon />
        </span>
      </div>
    </Link>
  );
};
